import { Badge } from "@shared/ui/badge";
import { Card, CardContent } from "@shared/ui/card";
import { Progress } from "@shared/ui/progress";

export const ConditionParameterTab: React.FC<{ data: any }> = ({ data }) => {
  const getScoreColor = (score: number) => {
    if (score >= 4) return "text-green-600";
    if (score >= 3) return "text-yellow-600";
    return "text-red-600";
  };

  return (
    <div>
      <Card>
        <CardContent className="mt-3">
          <div className="space-y-4">
            {data?.assetParameters?.map((param: any, index: any) => (
              <div
                key={index}
                className="border rounded-lg p-4 hover:bg-gray-50 cursor-pointer transition-colors"
              >
                <div className="flex items-center justify-between">
                  <div className="flex-1">
                    <div className="flex items-center gap-3">
                      <span className="font-medium">
                        {param.parameter || "N/A"}
                      </span>
                      <Badge variant="outline">
                        {param.weightage || 0}% Weight
                      </Badge>
                    </div>
                  </div>
                  <div className="flex items-center gap-4">
                    <div className="text-right">
                      <div
                        className={`text-lg font-semibold ${getScoreColor(
                          param.score
                        )}`}
                      >
                        {param.score || 0}/5
                      </div>
                      <div className="text-xs text-gray-500">Score</div>
                    </div>
                    <Progress
                      value={param.score * 20 || 0}
                      className="w-20 h-2"
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
